<div class="h-100 success d-flex flex-column align-items-stretch">
  <div class="success-header">
    <div class="mx-lg-15 px-lg-15 mx-5">
      <div class="header d-flex justify-content-between py-4">
        <div class="header-logo d-flex align-items-center">
          <img src="/assets/icons/Logo.svg" alt="">
          <span class="ms-3 fs-4 fw-bold text-primblack">
            Improvemath
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="container flex-grow-1 pb-md-15 d-flex justify-content-center flex-column" *ngIf="status !== ''">
    <div
      *ngIf="status === 'success'"
      class="row justify-content-center">
      <div class="col-10 col-sm-6 col-lg-4 d-flex flex-column align-items-center">
        <img src="/assets/success.png" alt="" class="w-100 mb-5">
      </div>
    </div>
    <div
      *ngIf="status !== 'success'"
      class="row justify-content-center">
      <div class="col-8 col-sm-6 col-lg-4 d-flex flex-column align-items-center">
        <img src="/assets/error.png" alt="" class="w-100 mb-5">
      </div>
    </div>
    <div
      *ngIf="status !== 'success'"
      class="row justify-content-center">
      <div class="col-12 col-sm-9 col-lg-9 d-flex flex-column align-items-center">
        <p class="fs-2 fw-bold text-center text-primblack px-lg-8">
          Unfortunately, the payment has been declined by your bank. Try the following steps:
        </p>
        <div class="mb-8">
          <p class="fs-3 text-primblack">
            <img src="/assets/icons/check_do.svg" alt="">
            Check your card balance
          </p>
          <p class="fs-3 text-primblack">
            <img src="/assets/icons/check_do.svg" alt="">
            Check your card balance
          </p>
          <p class="fs-3 text-primblack">
            <img src="/assets/icons/check_do.svg" alt="">
            Contact your bank
          </p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-10 col-sm-6 col-lg-4 d-flex flex-column align-items-center">
        <button
          type="button"
          class="btn app-btn-yellow btn-outline w-100"
          (click)="continueBtnClick()"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
